import { X } from "lucide-react";

export default function RangeInputs({ type = "number", label, value = [null, null], onChange, showClear = false, disableFuture = false, disablePast = false, allowToday = true }) {
  const handleInputChange = (index) => (e) => {
    const newValue = [...value];
    const val = e.target.value === "" ? null : type === "date" ? e.target.value : Number(e.target.value);
    newValue[index] = val;
    onChange(newValue);
  };

  const handleClear = () => {
    onChange([null, null]);
  };

  const today = new Date().toISOString().split("T")[0];

  const maxDate = disableFuture ? (allowToday ? today : new Date(Date.now() - 86400000).toISOString().split("T")[0]) : undefined;

  const minDate = disablePast ? (allowToday ? today : new Date(Date.now() + 86400000).toISOString().split("T")[0]) : undefined;

  return (
    <div className="input_field items-stretch space-x-1 py-0 sm:py-1 md:py-1">
      <p className="text-slate-500/90 whitespace-nowrap min-w-24 text-left w-max-content">{label}</p>

      <input type={type} className="px-2 sm:py-1 md:py-2 w-full text-center border rounded !outline-none border-slate-200 text-black" value={value[0] ?? ""} onChange={handleInputChange(0)} placeholder="From" min={type === "date" ? minDate : undefined} max={type === "date" ? maxDate : undefined} />

      <span
        className={`!border !border-gray-300 rounded
    ${type === "date" ? "hidden md:inline-block px-0" : "px-1 md:px-2"}`}
      ></span>

      <input type={type} className="px-2 sm:py-1 md:py-2 w-full text-center border rounded !outline-none border-slate-200 text-black" value={value[1] ?? ""} onChange={handleInputChange(1)} placeholder="To" min={type === "date" ? minDate : undefined} max={type === "date" ? maxDate : undefined} />

      {showClear && (value[0] !== null || value[1] !== null) && (
        <button type="button" onClick={handleClear} className="!-ml-3 text-sm text-red-500 hover:text-red-700 whitespace-nowrap cursor-pointer bg-gray-200/70 hover:bg-gray-200/100 rounded-full !p-1">
          <X className="" />
        </button>
      )}
    </div>
  );
}
